export default "__VITE_ASSET__CvwiRyXs__"